export const propertyFilterPlaceholder = () => {
  const locationsPlaceholder = document.querySelector(
    '#dfg-custom-filters .dp-dfg-filters-dropdown-layout .dp-dfg-filters-dropdown .dp-dfg-dropdown-placeholder',
  );
  const propertyTypePlacedholer = document.querySelector(
    '#dfg-custom-filters .dp-dfg-filters-dropdown-layout .dp-dfg-filters-dropdown:nth-child(2) .dp-dfg-dropdown-placeholder',
  );
  const statusPlaceholder = document.querySelector(
    '#dfg-custom-filters .dp-dfg-filters-dropdown-layout .dp-dfg-filters-dropdown:nth-child(3) .dp-dfg-dropdown-placeholder',
  );

  if (locationsPlaceholder) {
    locationsPlaceholder.innerHTML = 'All Locations';
  }

  if (propertyTypePlacedholer) {
    propertyTypePlacedholer.innerHTML = 'All Property Types';
  }

  if (statusPlaceholder) {
    statusPlaceholder.innerHTML = 'Status';
  }
};
